interface LabModeBarProps {
  engineerMode: boolean;
  showEditTargets: boolean;
  showParity: boolean;
  onEngineerModeChange: (value: boolean) => void;
  onShowEditTargetsChange: (value: boolean) => void;
  onShowParityChange: (value: boolean) => void;
  /** Engineer fixture actions (shown in the tools block). */
  onExportJson?: () => void;
  onResetFixture?: () => void;
  exportDisabled?: boolean;
  resetDisabled?: boolean;
}

export function LabModeBar({
  engineerMode,
  showEditTargets,
  showParity,
  onEngineerModeChange,
  onShowEditTargetsChange,
  onShowParityChange,
  onExportJson,
  onResetFixture,
  exportDisabled = false,
  resetDisabled = false,
}: LabModeBarProps) {
  return (
    <div className="lab-mode-row">
      <div className="lab-mode-bar" role="group" aria-label="View mode">
        <label className="lab-mode-bar__item">
          <input
            type="radio"
            name="lab-mode"
            checked={!engineerMode}
            onChange={() => onEngineerModeChange(false)}
          />
          Design
        </label>
        <label className="lab-mode-bar__item">
          <input
            type="radio"
            name="lab-mode"
            checked={engineerMode}
            onChange={() => onEngineerModeChange(true)}
          />
          Engineer
        </label>
      </div>

      <div className="lab-mode-bar" role="group" aria-label="Lab tools">
        <label className="lab-mode-bar__item">
          <input
            type="checkbox"
            checked={showEditTargets}
            onChange={(e) => onShowEditTargetsChange(e.target.checked)}
          />
          Edit-target overlay
        </label>
        {onExportJson ? (
          <>
            <span className="lab-mode-bar__sep" aria-hidden />
            <button
              type="button"
              className="lab-btn lab-btn--ghost"
              onClick={onExportJson}
              disabled={!engineerMode || exportDisabled}
            >
              Export JSON
            </button>
          </>
        ) : null}
        <button
          type="button"
          className={`lab-btn lab-btn--ghost${showParity ? ' lab-btn--active' : ''}`}
          onClick={() => onShowParityChange(!showParity)}
          disabled={!engineerMode}
          aria-pressed={showParity}
        >
          SSR Checkup
        </button>
        {onResetFixture ? (
          <button
            type="button"
            className="lab-btn lab-btn--ghost"
            onClick={onResetFixture}
            disabled={!engineerMode || resetDisabled}
          >
            Reset
          </button>
        ) : null}
      </div>
    </div>
  );
}
